<template>
  <div class="book-table">
    <el-table
      :data="list" 
      :row-class-name="tableRowClassName"
      :row-style="rowClassName"
      style="width: 100%"
      @row-click="rowActive"
      height="380"
      >
      <!-- border -->

      <el-table-column 
        type="index" 
        label="序号"
        align="center"
        fixed
        width="70">
      </el-table-column> 
      <el-table-column
        prop="readtime"
        align="center"
        fixed
        label="阅读时间" >
      </el-table-column> 
      <el-table-column
        prop="title"
        fixed
        align="center"
        label="书名">
        <template slot-scope="scope">
            <!-- <el-tooltip class="item" effect="light" :content="scope.row.bookName" placement="right"> -->
                <span>{{scope.row.bookName}}</span>
            <!-- </el-tooltip> -->
        </template>
      </el-table-column> 
    </el-table>
  </div>
</template>

<script> 
export default {
  name: "headerCom",
  props:{
    list:Array
  },
  data() {
    return { 
        tableData: []
    };
  },
  computed: {
      tableData_(){
          return this.tableData.map((item,index)=>{
              return {
                  serialNumber:index+1 , //序号
                  bookName:"册名" , //册名 
                  title:"篇名" , //篇名
                  watcher:"注译者" , //注译者
                  source:"出处" , //出处
                  publicationDate:"发表日期" , //发表日期
                  category:"类别" , //类别
                  remarks:"备注" , //备注 
              }
          })
      }
  }, 
  methods: {
      rowActive(row){ 
          this.$emit("row-click",{
              data:row
          })
      },
      rowClassName(){
          return 'row-height'
      },
      tableRowClassName({rowIndex}) { 
        if((rowIndex & 1) == 0){ //偶数
            return 'warning-row';
        }else{//奇数
            return 'success-row'
            } 
      }
  },
  mounted() {
    
  }
};
</script>
<style>
    .el-table th {
        background-color: #a19183;
        color: #f0ebe1;
    } 
    .el-table td {
        padding: 5px 0; 
    } 
    .el-table tr{
        cursor: pointer;
    } 
    .el-table tbody tr:hover>td { 
    background-color:#d4cdc2!important
}
  .el-table .warning-row {
    background:#fff;
  }

  .el-table .success-row {
    background: #e7e1e1;
  }
  .el-table .row-height{
      height: 20px;
  }
</style>
<style lang="less" scoped>
    .book-table{
        border-radius: 6px;
        overflow: hidden;
    }
</style> 
